import type { FC } from 'react';
import { Link } from 'umi';
import { LOGO_IMG } from '@/utils/constant';
import { trace } from '@/utils/trace';
import Stepper from '../Stepper';
import type { StepperProps } from '../Stepper';

type IProps = {
  title?: string;
  stepper?: StepperProps;
  children?: React.ReactNode;
};

const OrderHeader: FC<IProps> = ({ title, stepper, children }) => {
  const handleTrace = () => {
    trace('btn_click', {
      btn_name: '商城logo',
      desc: '商城logo,点击跳转',
      link_page_url: '/',
    });
  };
  return (
    <div className="flex border-b border-solid border-[#B9B9B9] flex-col">
      <div className="flex flex-row justify-between items-center h-[120px]">
        <div className="inline-flex items-center">
          <Link to="/" onClick={handleTrace}>
            <img
              className="w-[116px] cursor-pointer"
              src={LOGO_IMG}
              alt="beukay-logo"
            />
          </Link>
          {!!title && <span className="ml-5 text-22 font-medium">{title}</span>}
        </div>
        {!!stepper && <Stepper {...stepper} />}
      </div>
      <div>{children}</div>
    </div>
  );
};

export default OrderHeader;
